<template>
  <!-- filtros -->
  <div class="row w-100% h-12 position-relative">
    <div class="scroll-horizontal h-100% w-100% pt-3 pb-1">
      <button
        v-show="ItemSearch.rango != 'Bolivia'"
        :class="[
          selectSwichMarker == true
            ? 'bg-primary text-white hover:bg-primary-1'
            : 'bg-white text-primary hover:bg-white-1',
        ]"
        class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        @click="
          selectSwichMarker = !selectSwichMarker;
          _selectMarkers(selectSwichMarker);
        ">
        <label class="h-100% pv-1 cursor-pointer mr-1"
          >Visualizar Comunidades</label
        >
        <span
          class="
            icon-marker
            mt-1
            border-radius-4
            ph-1
            pv-1
            bg-primary-1
            text-white
            hover:bg-primary-2
            cursor-pointer
          "
        ></span>
      </button>

      <div
        v-show="ItemSearch.rango == 'Comunidad'"
        class="h-100% d-inline-block"
      >
        <button
          :class="[
            selectFiltroComunidad == 0
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-5 mr-1 ml-3 border-radius-5 cursor-pointer"
          @click="
            selectFiltroComunidad = 0;
            _selectItem({
              filter:'municipal',
              title: 'ICCOM Municipal - Bolivia',
              subtitle: '',
              url_filtro: '',
              url_estadistica: '/ica-comunidad',
            });
          "
        >
          ICCOM Municipal
        </button>

        <button
          :class="[
            selectFiltroComunidad == 1
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroComunidad = 1;
              filtroSelected = {
                filter:'disponibilidad',
                title: 'ICCOM Disponibilidad',
                subtitle: '',
                url_filtro: '',
                url_estadistica: '/ica-comunidad-disponibilidad',
                columna_filtro: '',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Disponibilidad</label
          >
        </button>
        <button
          :class="[
            selectFiltroComunidad == 2
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroComunidad = 2;
              filtroSelected = {
                filter:'acceso',
                title: 'ICCOM Acceso',
                subtitle: '',
                url_filtro: '',
                url_estadistica: '/ica-comunidad-acceso',
                columna_filtro: '',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Acceso</label
          >
        </button>

        <button
          :class="[
            selectFiltroComunidad == 3
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroComunidad = 3;
              filtroSelected = {
                filter:'uso',
                title: 'ICCOM Uso',
                subtitle: '',
                url_filtro: '',
                url_estadistica: '/ica-comunidad-uso',
                columna_filtro: '',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Uso</label
          >
          <!-- <span
            class="
              icon-menu
              mt-1
              border-radius-4
              ph-1
              pv-1
              bg-primary-1
              text-white
              hover:bg-primary-2
              cursor-pointer
            "
            @click="
              selectFiltroComunidad = 3;
              filtroSelected = {
                title: 'ICCOM Uso Municipales',
                subtitle: '',
                url_filtro: '/indice-usos',
                url_estadistica: '/estadistica-usos',
              };
              columnas = columnasUso;
              modalColumnas = true;
            "
          ></span> -->
        </button>

        <button
          :class="[
            selectFiltroComunidad == 4
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
          @click="
            selectFiltroComunidad = 4;
            filtroSelected = {
              title: 'ICCOM Cultivos',
              subtitle: '',
              url_filtro: '',
              url_estadistica: '/ica-cultivos-comunidad',
            };
            columnas = columnasCultivos;
            modalColumnas = true;
          "
        >
          ICCOM Cultivos
        </button>

        <button
          :class="[
            selectFiltroComunidad == 5
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5"
          @click="modalComunidadConsolidado = true"
        >
          Datos consolidados
        </button>
      </div>

      <div
        v-show="ItemSearch.rango == 'Municipio'"
        class="h-100% d-inline-block"
      >
        <button
          :class="[
            selectFiltroMunicipio == 0
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-5 mr-1 ml-3 border-radius-5 cursor-pointer"
          @click="
            selectFiltroMunicipio = 0;
            _selectItem({
              filter:'municipal',
              title: 'ICCOM Municipal',
              subtitle: '',
              url_filtro: '/consolidado-ica',
              url_estadistica: '/estadistica-ica',
            });
          "
        >
          ICCOM Municipal
        </button>
        <button
          :class="[
            selectFiltroMunicipio == 1
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroMunicipio = 1;
              filtroSelected = {
                title: 'ICCOM Disponibilidad',
                subtitle: '',
                url_filtro: '/indice-disponibilidades',
                url_estadistica: '/estadistica-disponibilidad',
                columna_filtro: 'disponibilidad',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Disponibilidad</label
          >
          <span
            class="
              icon-menu
              mt-1
              border-radius-4
              ph-1
              pv-1
              bg-primary-1
              text-white
              hover:bg-primary-2
              cursor-pointer
            "
            @click="
              selectFiltroMunicipio = 1;
              filtroSelected = {
                filter:'disponibilidad',
                title: 'ICCOM Disponibilidad',
                subtitle: '',
                url_filtro: '/indice-disponibilidades',
                url_estadistica: '/estadistica-disponibilidad',
              };
              columnas = columnasDisponibilidad;
              modalColumnas = true;
            "
          ></span>
        </button>
        <button
          :class="[
            selectFiltroMunicipio == 2
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroMunicipio = 2;
              filtroSelected = {
                title: 'ICCOM Acceso',
                subtitle: '',
                url_filtro: '/indice-accesos',
                url_estadistica: '/estadistica-accesos',
                columna_filtro: 'acceso',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Acceso</label
          >
          <span
            class="
              icon-menu
              mt-1
              border-radius-4
              ph-1
              pv-1
              bg-primary-1
              text-white
              hover:bg-primary-2
              cursor-pointer
            "
            @click="
              selectFiltroMunicipio = 2;
              filtroSelected = {
                filter:'acceso',
                title: 'ICCOM Acceso',
                subtitle: '',
                url_filtro: '/indice-accesos',
                url_estadistica: '/estadistica-accesos',
              };
              columnas = columnasAcceso;
              modalColumnas = true;
            "
          ></span>
        </button>

        <button
          :class="[
            selectFiltroMunicipio == 3
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroMunicipio = 3;
              filtroSelected = {
                title: 'ICCOM Uso',
                subtitle: '',
                url_filtro: '/indice-usos',
                url_estadistica: '/estadistica-usos',
                columna_filtro: 'uso',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Uso</label
          >
          <span
            class="
              icon-menu
              mt-1
              border-radius-4
              ph-1
              pv-1
              text-white
              bg-primary-1
              hover:bg-primary-2
              cursor-pointer
            "
            @click="
              selectFiltroMunicipio = 3;
              filtroSelected = {
                filter:'uso',
                title: 'ICCOM Uso',
                subtitle: '',
                url_filtro: '/indice-usos',
                url_estadistica: '/estadistica-usos',
              };
              columnas = columnasUso;
              modalColumnas = true;
            "
          ></span>
        </button>

        <button
          :class="[
            selectFiltroMunicipio == 4
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
          @click="
            selectFiltroMunicipio = 4;
            filtroSelected = {
              title: 'ICCOM Cultivos',
              subtitle: '',
              url_filtro: '/indice-cultivos',
              url_estadistica: '/estadistica-cultivos',
            };
            columnas = columnasCultivos;
            modalColumnas = true;
          "
        >
          ICCOM Cultivos
        </button>

        <button
          :class="[
            selectFiltroMunicipio == 5
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5"
          @click="modalConsolidado = true"
        >
          Datos consolidados
        </button>
      </div>

      <div v-show="ItemSearch.rango == 'Bolivia'" class="h-100% d-inline-block">
        <button
          :class="[
            selectFiltroBolivia == 0
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-5 mr-1 ml-3 border-radius-5 cursor-pointer"
          @click="
            selectFiltroBolivia = 0;
            _selectItem({
              title: 'ICCOM Municipales',
              subtitle: '',
              url_estadistica: '/estadistica-ica',
              url_filtro: '/consolidado-ica',
            });
          "
        >
          ICCOM Municipales
        </button>
        <button
          :class="[
            selectFiltroBolivia == 1
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroBolivia = 1;
              filtroSelected = {
                title: 'ICCOM Disponibilidad Municipales',
                subtitle: '',
                url_filtro: '/indice-disponibilidades',
                url_estadistica: '/estadistica-disponibilidad',
                columna_filtro: 'disponibilidad',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Disponibilidad</label
          >
          <span
            class="
              icon-menu
              mt-1
              border-radius-4
              ph-1
              pv-1
              bg-primary-1
              text-white
              hover:bg-primary-2
              cursor-pointer
            "
            @click="
              selectFiltroBolivia = 1;
              filtroSelected = {
                filter:'disponibilidad',
                title: 'ICCOM Disponibilidad Municipales',
                subtitle: '',
                url_filtro: '/indice-disponibilidades',
                url_estadistica: '/estadistica-disponibilidad',
              };
              columnas = columnasDisponibilidad;
              modalColumnas = true;
            "
          ></span>
        </button>
        <button
          :class="[
            selectFiltroBolivia == 2
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroBolivia = 2;
              filtroSelected = {
                title: 'ICCOM Acceso Municipales',
                subtitle: '',
                url_filtro: '/indice-accesos',
                url_estadistica: '/estadistica-accesos',
                columna_filtro: 'acceso',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Acceso</label
          >
          <span
            class="
              icon-menu
              mt-1
              border-radius-4
              ph-1
              pv-1
              bg-primary-1
              text-white
              hover:bg-primary-2
              cursor-pointer
            "
            @click="
              selectFiltroBolivia = 2;
              filtroSelected = {
                filter:'acceso',
                title: 'ICCOM Acceso Municipales',
                subtitle: '',
                url_filtro: '/indice-accesos',
                url_estadistica: '/estadistica-accesos',
              };
              columnas = columnasAcceso;
              modalColumnas = true;
            "
          ></span>
        </button>

        <button
          :class="[
            selectFiltroBolivia == 3
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
        >
          <label
            class="h-100% pv-1 cursor-pointer mr-1"
            @click="
              selectFiltroBolivia = 3;
              filtroSelected = {
                title: 'ICCOM Uso Municipales',
                subtitle: '',
                url_filtro: '/indice-usos',
                url_estadistica: '/estadistica-usos',
                columna_filtro: 'uso',
              };
              _selectItem(filtroSelected);
            "
            >ICCOM Uso</label
          >
          <span
            class="
              icon-menu
              mt-1
              border-radius-4
              ph-1
              pv-1
              bg-primary-1
              text-white
              hover:bg-primary-2
              cursor-pointer
            "
            @click="
              selectFiltroBolivia = 3;
              filtroSelected = {
                filter:'uso',
                title: 'ICCOM Uso Municipales',
                subtitle: '',
                url_filtro: '/indice-usos',
                url_estadistica: '/estadistica-usos',
              };
              columnas = columnasUso;
              modalColumnas = true;
            "
          ></span>
        </button>

        <button
          :class="[
            selectFiltroBolivia == 4
              ? 'bg-primary text-white hover:bg-primary-1'
              : 'bg-white text-primary hover:bg-white-1',
          ]"
          class="h-100% ph-2 mr-1 border-radius-5 cursor-pointer"
          @click="
            selectFiltroBolivia = 4;
            filtroSelected = {
              title: 'ICCOM Cultivos Municipales',
              subtitle: '',
              url_filtro: '/indice-cultivos',
              url_estadistica: '/estadistica-cultivos',
            };
            columnas = columnasCultivos;
            modalColumnas = true;
          "
        >
          ICCOM Cultivos
        </button>
        <!-- <button
        class="h-100% bg-primary text-white ph-2 mr-1 border-radius-5"
       
      >
        Datos consolidados Municipales
      </button> -->
      </div>
    </div>

    <!-- modal filtros hijos -->
    <div
      v-if="modalColumnas"
      class="
        us:bg-modal-transparent
        fade-in
        col
        w-100%
        h-100%
        top-0
        left-0
        position-fixed
        z-3
        align-center
        justify-center
      "
    >
      <div
        class="
          col
          sm:w-90% sm:h-80%
          md:w-40% md:h-80%
          col
          align-center
          sm:p-2
          md:p-5
        ">

       

        <div class="row w-100% justify-center aling-center mb-3">
          <h3
            class="text-white bold ph-2 pv-1 border-radius-3 text-center"
            style="background-color: #00000083"
          >
            {{ filtroSelected.title }}
          </h3>
        </div>

        <div class="flex-1 position-relative w-100%">
          <div class="scroll-vertical ph-3">
            <template class="col align-center">
              <div
                class="
                  bg-primary-1
                  text-white
                  ph-2
                  pv-1
                  mb-2
                  hover:bg-primary
                  cursor-pointer
                  border-radius-3
                  shadow-2
                  text-center
                  w-fit-content
                "
                v-for="(item, index) in columnas"
                :key="index"
                @click="
                  modalColumnas = false;
                  filtroSelected.columna_filtro = item.columna;
                  filtroSelected.subtitle = item.etiqueta;
                  if (GLOBAL.isKeyExists(item, 'subcolumnas')) {
                    filtroSelected.subcolumnas = item.subcolumnas;
                  }
                  _selectItem(filtroSelected);
                "
              >
                {{ item.etiqueta }}
              </div>
            </template>
           </div>
       </div>

        <div
          @click="modalColumnas = false"
          class="
            row
            w-fit-content
            cursor-pointer
            hover:bg-dark
            align-center
            mb-3
            ph-2
            pv-1
            border-radius-3
          "
          style="background-color: #00000083"
        >
          <h3 class="text-white bold">Cancelar</h3>
          <i class="icon-cancel text-white text-size-4 ml-2"></i>
        </div>
       
      </div>
    </div>

    <ConsolidadoMunicipioModal
      :codigo_municipio="ItemSearch.codigo"
      v-if="modalConsolidado"
      @closeModal="modalConsolidado = false"
    ></ConsolidadoMunicipioModal>

    <ConsolidadoComunidadModal
      :codigo_comunidad="ItemSearch.codigo_ine"
      v-if="modalComunidadConsolidado"
      @closeModal="modalComunidadConsolidado = false"
    ></ConsolidadoComunidadModal>
  </div>
  <!-- end filtros -->
</template>

<script>
import MapaService from "@/services/mapa.service";
import ConsolidadoMunicipioModal from "./ConsolidadoMunicipioModal";
import ConsolidadoComunidadModal from "./ConsolidadoComunidadModal";

let me = null;
export default {
  props: ["ItemSearch"],
  components: { ConsolidadoMunicipioModal, ConsolidadoComunidadModal },
  data() {
    return {
      //marcador de posiciones
      selectSwichMarker: false,
      selectFiltroComunidad: 0,
      selectFiltroMunicipio: 0,
      selectFiltroBolivia: 0,
      //modalse
      modalConsolidado: false,
      modalComunidadConsolidado: false,
      modalColumnas: false,
      //datos
      filtroSelected: null,

      columnas: [],
      columnasDisponibilidad: [
        { etiqueta: "Amenaza sequia", columna: "amenaza_sequia" },
        { etiqueta: "Amenaza Helada", columna: "amenaza_helada" },
        { etiqueta: "Amenaza Granizo", columna: "amenaza_granizo" },
        {
          etiqueta: "Sensibilidad Agropecuaria",
          columna: "sensibilidad_agropecuario",
        },
        {
          etiqueta: "Sensibilidad Desarrollo Productivo",
          columna: "sensibilidad_desarrollo_productivo",
        },
        {
          etiqueta: "Cobertura de calorias por Habitantes",
          columna: "cobertura_calorias",
        },
        {
          etiqueta: "Cobertura de proteinas por Habitantes",
          columna: "cobertura_proteinas",
        },
        { etiqueta: "Suma de eventos", columna: "suma_eventos" },
        { etiqueta: "Seguro agricola", columna: "seguro_agricola" },
        {
          etiqueta: "Construcciones por HA agricola",
          columna: "construccion_ha_agricola",
        },
        {
          etiqueta: "% actividad Comercial",
          columna: "porcentaje_actividad_comercial",
        },
        {
          etiqueta: "UPAS caza respecto al total",
          columna: "upa_caza",
        },
        {
          etiqueta: "UPAS pesca respecto al total",
          columna: "upa_pesca",
        },
      ],
      columnasAcceso: [
        {
          etiqueta: "% poblacion pobre NBI 2012",
          columna: "porcentaje_poblacion_pobrenbi2012",
        },
        {
          etiqueta: "Sensibilidad del transporte terrestre",
          columna: "sensibilidad_transporte_terrestre",
        },
        {
          etiqueta: "Indice de baja urbanidad",
          columna: "indice_baja_urbanidad",
        },
        { etiqueta: "Indice de ingresos", columna: "indice_ingresos" },
        {
          etiqueta: "% de poblacion pobrePoblacion al 2020",
          columna: "porcentaje_poblacion_pobre2020",
        },
        { etiqueta: "IDINA", columna: "idina" },
        {
          etiqueta: "Promedio tasa de abandono 10 años",
          columna: "promedio_taza_abandono",
        },
        {
          etiqueta: "Amenza sequiaAmenaza inundacion",
          columna: "amenaza_inundacion",
        },
      ],
      columnasUso: [
        {
          etiqueta: "Sensibilidad de servicios básicos",
          columna: "sensibilidad_servicios_basicos",
        },
        { etiqueta: "Incidencia de anemia", columna: "indice_anemia" },
        { etiqueta: "incidencia de IRAS", columna: "indice_iras" },
        { etiqueta: "incidencia de EDAs", columna: "indice_edas" },
        {
          etiqueta: "incidencia de desnutricion",
          columna: "indice_desnutricion",
        },
        { etiqueta: "tasa de nalfabetismo", columna: "tasa_analfabetismo" },
        { etiqueta: "sensibilidad social", columna: "sencibilidad_social" },
        {
          etiqueta: "Amenaza sequiaamenaza inundación",
          columna: "amenaza_sequia",
        },
      ],
      columnasCultivos: [
        {
          etiqueta: "Caña de azúcar y remolacha azucarera",
          columna: "total_cana_azucar_y_remolacha_azucarera",
          subcolumnas:
            "cana_de_azucar||total_cana_azucar_y_remolacha_azucarera ",
        },
        {
          etiqueta: "Cereales",
          columna: "total_cereales",
          subcolumnas:
            "alpiste||amaranto||arroz_con_cascara||avena||canawa||cebada_en_grano||centeno||maiz||quinua||sorgo||trigo||total_cereales",
        },
        {
          etiqueta: "Total Frutos o granos oleaginosos",
          columna: "total_frutos_o_granos_oleaginosos ",
          subcolumnas:
            "cartamo||chia||cocos_con_cascara||cultivo_de_majo||grano_de_girasol||linaza||mani||motacu||oliva||sesamo||soya",
        },

        {
          etiqueta: "Total Frutas y nueces",
          columna: "total_frutas_y_nueces",
          subcolumnas:
            "acerola||achachairu||albarillo||almendra_con_cascara||arandano||araza||avellana||bi||biriba||camu_camu||carambola||castaña||cayu||chirimoya||cidra||ciruelo||copoazu||cultivo_de_moringa||damasco||datiles||durazno||frambuesa||fresa||frutilla||granada||granadilla||guanabana||guapomo||guapuru||guayaba||guinda||higo||jaca||kinoto||kiwi||lima||limon||locosti||lucuma||lujma||mandarina||mangos||manzana||maracuya||membrillo||mora||motoyoe||naranja||nispero||noni||nuez||nues_de_macadamia||ocoro||otras_cerezas||otras_frutas_de_hueso_n_c_p||pacay||palta||pan_de_fruta||papaya||pera||peramota||piña||pistacho||platano_banano||platano_postre||rambutan||tamarindo||tcv_citricos||tcv_frutas||tcv_hortalizas_y_frutales||toronja||tumbo||tuna||uva||zarzamora||total_frutas_y_nueces",
        },
        {
          etiqueta: "Total Legumbres secas",
          columna: "total_legumbres_secas",
          subcolumnas:
            "arveja_de_gandul||arveja_seca||frijol||frijol_lima||garbanzo||haba_seca||lenteja||nuna||tarwi||total_legumbres_secas",
        },
        {
          etiqueta: "Total Hortalizas",
          columna: "total_hortalizas",
          subcolumnas:
            "acelga||achicoria||achojcha||aji_verde||ajo||albahaca||alcachofa||apio||aribibi||arveja_verde||berenjena||berro||betarraga||brocoli||calabaza||cebolla||cilantro||coles||coliflor||crotalaria||cultivo_tucula||esparragos||espinaca||frijoles_verdes||haba_verde||hongo||huacataya||lechuga||locoto||melon||nabo||okra||palmito||pepino||perejil||pimenton||puerro||quirquiña||rabano||sandia||tcv_hortalizas||tcv_leguminosos||tomate||ulupica||vainita||verdolaga||zanahoria||zapallo||total_hortalizas",
        },
        {
          etiqueta: "Total Otros Usos de la Tierra",
          columna: "total_otros_usos_de_tierra",
          subcolumnas:
            "bosques_o_montes||otras_tierras||pastos_naturales||tierras_en_barbecho||tierras_en_descanso||total_otros_usos_de_tierra",
        },
        {
          etiqueta:
            "Total Cultivo de plantas con las que se preparan bebidas estimulantes, especias y plantas aromáticas",
          columna: "total_cultivo_plantas_bebidas_estimulantes",
          subcolumnas:
            "achiote||ajenjo||aji||alcanfor||anis||azafran||boldo||boton_de_oro||cacao||cafe||canela||carqueja||cedron||comino||echinacea||estevia||flor_de_pascua||hierba_mate||hierbabuena||hinojo||hoja_de_laurel||jamaica||jengibre||kana_yuyo||lavanda||menta||oregano||poleo||primula||ruda||ruivardo||sabila||te||tomillo||vainilla||total_cultivo_plantas_bebidas_estimulantes",
        },
        {
          etiqueta: "Total Madera sin elaborar",
          columna: "total_matera_sin_elaborar",
          subcolumnas:
            "alamo||algarrobillo||algarrobo||algodoncillo||aliso||amargo||amarillo||araucarias||arbol_aceituna||arbol_ajo||arbol_almendrillo||arbol_cari_cari||arbol_canela||arbol_chocolate||arbol_laurel||arbol_mora||arbol_duraznillo||arbol_espina_mar||arbol_guayabillo||arbol_higuera||arbol_limoncillo||arbol_lucuma||arbol_mangaba||arbol_mani||arbol_manzanillo||arbol_mata_palo||arbol_melendre||arbol_mora||arbol_motoyoe||arbol_naranjillo||arbol_pacay||arbol_paito||arbol_paito_laurel||arbol_pan||arbol_piton||arbol_vedolango||arrayan||bacuri||barataballi||berlinia||bibosi||bitumbo||blanquillo||cachichira||cambara||melon||carapari||carnaval||carne_de_vaca||catuaba||cedrilo||cedro||ceibo||chamba||chari||chirimoya_del_monte||chocolatillo||churqui_de_recoleccion||chuy||cipreses||coca_coca||coloradillo||colorado||copaibo||copal||coquino||crespito||cuchi||cunuri||curupau||cuta||descripciones_genericas_especiales||enchoque||eucalipto||gabetillo||gabun||grevillea||guayabochi||guayacan||guitarrero||huito||incienso||isigo||itauba||japunaqui||jarca||jarquilla||jichituriqui||jocori||lanza||leche_leche||lechero||leña||lloque||madera_ajipa||manicillo||mara||mara_macho||marfil||masaranduba||mascajo||mataco||mayi||melina||mindiola||miso||miso_blanco||molle||momoqui||morado||morilla||name||negrillo||nogal||ochoo||olmo||palo_blanco||palo_fosforo||palo_maria||palo_roman||palo_yugo||palo_zapallo||paquio||paquiosillo||paraiso||pecan||perilla||pesoe||picana||pino||piraquina||pito_talega||puka||punero||quebracho||queñua||quina_quina||quiswara||roble||sahuinto||sangre_de_toro||sarari||sauce||sauco||seque||serebo||simayo||sotillo||soto||sujo||tamarindillo||taquillo||tarara||tarco_o_jacaranda||turuma||tcv_maderables||teca||thola||timboy||tinto||tipa||toco||toco_colorado||trompa_de_anta||trompillo||tumi||urupi||urundel||uvillo||vinal||vitaca||willca||yeguaparaqui||yesquero||total_matera_sin_elaborar",
        },
        {
          etiqueta: "Total general TCV forestales",
          columna: "total_general_tcv_forestales",
          subcolumnas: "tcvforestales||total_general_tcv_forestales",
        },
        {
          etiqueta: "Total Raíces y tubérculos comestibles ricos en almidón",
          columna: "total_raices_tuberculos",
          subcolumnas:
            "achira||ajipa||aricoma||camote||hualuza||izano||maca||name||oca||papa||papaliza||racacha||tcv_tuberculos||yuca||total_raices_tuberculos",
        },
        {
          etiqueta:
            "Total Productos del forraje, fibras, plantas vivas, corte las flores y los brotes de la flor, tabaco no procesado, y caucho natural",
          columna: "total_productos_plantas_vivas",
          subcolumnas:
            "agapando||aleli||alfalfa||algodon_en_fibra||arveja_forrajera||astromelia||avena_forrajera||azucena||balsamina||barba_de_chivo||barbasco||becumbe||begonia||boca_y_sapo||braquiara||bremura||buffel||cabuya||camerun||canastillo||cana_forrajera||canamo||canuela||capin||capuchina||carretilla||cartucho||caucho||cebajda_forrajera||centenario||chileno||chilliwa||churqui||clavel||coca||colonion||crisantemo||cucarda||dalia||descripciones_genericas_cultivos||desmodio||dichondra||espanita||estaticia||estrella||estrella_de_belen||flor_aleluya||flor_amancay||flor_anturia||flor_araña||flor_beiby||flor_bombom||flor_chispa||flor_copo_de_nieve||flor_de_la_reina||flor_gabriel||flor_ginger||flor_mansonia||flor_montecasino||flor_once_horas||flor_pimpinela||flores_capullos_cortados_ramilletes_coronas_arreglos_florales||fresia||garrotilla||gateadora||gatton_paning||geranio||gladiolo||glycine||gordura||gramalote||haba_forrajera||helecho||hierbaluisa||hortensia||humedicula||ilusion||jaragua||jazmin||kantuta||kikuyo||kudzu||layo||lechuga_forrajera||lechuguina||lilium||lirio||liwi_liwi||llamarada_de_fuego||lolium_multiflorum||maicillo||maiz_berza||mala_madre||mani_forrajero||maralfalfa||mombaza||mucuma||mulato||narciso||nardos||orejuela||otros_pastos_n_c_p||pangola||panico_verde||pasto_agropiro||pasto_amargo||pasto_arrocillo||pasto_ballico||pasto_brasilero||pasto_brizanta||pasto_bufalo||pasto_caribe||pasto_cauchi||pasto_citari||pasto_cola_de_raton||pasto_crespo||pasto_esmeralda||pasto_guinea||pasto_japones||pasto_lechero||pasto_lloron||pasto_mansonia||pasto_massai||pasto_merqueron||pasto_necella||pasto_ovillo||pasto_paraiso||pasto_plata||pasto_rogelio||pasto_ruso||pasto_tanzania||pasto_tobiata||pasto_vertivell||pemba||pensacola||petunia||plantas_ornamentales||popelina||primavera||quico||quiebra_barriga||quinua_berza||rambutan||ramio||rastrero||ray_grass||rebeca||retama||romero||rosales||ruzisiensis||santa_rita||saracacho||secga||siempre_viva||sillo_sillo||sisal||sorgo_escobero||sorgo_forraje||sudan||tabaco||taiwan||tcv_agroforestal||tcv_agrosilvopastoril||tcv_flores||tcv_forrajeros||tcv_medicinales||tcv_ornamentales||tcv_pastos||tcv_otros_en_general||totora||trebol_de_alejandrin||trigo_forrajero||triticale||tulipan||tumba_vieja||vicia||waca_pasto||yawara||yerba_guinea||zacate||total_productos_plantas_vivas",
        },
      ],
    };
  },
  mounted() {
    me = this;
    // console.log("rango" + this.ItemSearch.rango);
  },
  methods: {
    _selectItem(data) {
      me.$emit("selectItem", data);
    },
    _selectMarkers(data) {
      me.$emit("selectMarkers", data);
    },
    isShowMarker() {
      return me.selectSwichMarker;
    },
    setShowMarker(status) {
      me.selectSwichMarker = status;
    },

    DBgetIcaComunidad({ comunidad = "" }) {
      //dialogo de carga
      gudi.loading.show({
        message: "Recuperando datos, espere porfavor...",
      });
      //realizamos peticion al servicio
      MapaService.getConsolidadoIca({
        comunidad: comunidad,
      })
        .then((response) => {
          gudi.loading.clear();
          // console.log(response.data);
          var data = {
            data: response.data,
            url_estadistica: "estadistica-ica",
          };
          me.$emit("selectItem", data);
        })
        .catch(function (err) {
          gudi.loading.clear();
          console.log(err);
        });
    },
  },
};
</script>

<style>
</style>
